import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { HowToBody } from "@/components/HowToBody";
import { BookOpen, Sparkles, Store as StoreIcon, Library, Swords, Mountain, ArrowRight } from "lucide-react";

export default function HelpPage() {
  return (
    <div className="min-h-screen scroll-smooth" data-testid="help-page">
      {/* Hero */}
      <div className="relative overflow-hidden border-b border-white/5">
        <div className="absolute -top-32 right-0 w-[34rem] h-[34rem] rounded-full bg-cyan-500/10 blur-[140px] pointer-events-none" />
        <div className="absolute -bottom-40 -left-40 w-[30rem] h-[30rem] rounded-full bg-fuchsia-500/10 blur-[140px] pointer-events-none" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-14 sm:py-20 relative">
          <Link to="/" data-testid="help-back-home" className="inline-flex items-center gap-1.5 text-white/50 hover:text-white text-sm mb-6 transition-colors">
            <ArrowRight className="h-4 w-4 rotate-180" /> Back to Playden
          </Link>
          <div className="inline-flex items-center gap-2 hud-pill px-3 py-1 rounded-full text-[10px] font-mono uppercase tracking-[0.3em] text-amber-300 mb-5">
            <BookOpen className="h-3 w-3" /> The Player's Codex
          </div>
          <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl text-white tracking-[0.04em] leading-[0.95]">
            HOW TO PLAY<br />
            <span className="bg-gradient-to-r from-cyan-300 via-fuchsia-300 to-amber-300 bg-clip-text text-transparent">PLAYDEN.</span>
          </h1>
          <p className="text-white/60 mt-5 max-w-2xl text-base leading-relaxed">
            Everything you can do — collect, top up, open packs, battle in the Arena, race the Gauntlet, raid the Cavern, trade, host shows and climb the Path. Jump to any section, then dive straight into the action with the links inside.
          </p>
          <div className="mt-7 flex flex-wrap gap-3">
            <Button asChild data-testid="help-cta-store" className="bg-cyan-400 text-black hover:bg-cyan-300">
              <Link to="/store"><StoreIcon className="mr-2 h-4 w-4" /> Start in the Store</Link>
            </Button>
            <Button asChild variant="outline" data-testid="help-cta-collection" className="border-white/15 text-white hover:bg-white/5">
              <Link to="/collection"><Library className="mr-2 h-4 w-4" /> My Playden</Link>
            </Button>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10">
        <HowToBody />

        <div className="mt-8 rounded-2xl border border-white/10 bg-white/[0.02] p-6 text-center">
          <Sparkles className="h-7 w-7 text-cyan-300 mx-auto" />
          <h3 className="font-display text-2xl text-white tracking-[0.04em] mt-2">Ready to play?</h3>
          <p className="text-white/55 text-sm mt-1">Grab a pack, build a squad, and make your mark on the Playden.</p>
          <div className="mt-4 flex flex-wrap justify-center gap-2">
            <Button asChild className="bg-cyan-400 text-black hover:bg-cyan-300" data-testid="help-footer-store"><Link to="/store"><StoreIcon className="mr-2 h-4 w-4" /> Open the Store</Link></Button>
            <Button asChild className="bg-amber-400 text-black hover:bg-amber-300" data-testid="help-footer-arena"><Link to="/arena"><Swords className="mr-2 h-4 w-4" /> Enter the Arena</Link></Button>
            <Button asChild variant="outline" className="border-fuchsia-400/40 text-fuchsia-200 hover:bg-fuchsia-400/10" data-testid="help-footer-cavern"><Link to="/cavern"><Mountain className="mr-2 h-4 w-4" /> Raid the Cavern</Link></Button>
          </div>
        </div>
      </div>
    </div>
  );
}
